<template>
  <div class="container-fluid event-nav">
    <img :src="logo" style="width:128px;" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      logo: null,
    };
  },
  created() {
    console.log(this.$root);
    this.logo = process.env.VUE_APP_API_SERVER + this.$root.event.logo.url;
  },
};
</script>
<style lang="scss" scoped>
.event-nav {
  height: 72px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  background-color: #fff;
  position: relative;
  box-shadow: 0px 1px 4px #e6e6e6;
  z-index: 1;
  img {
    width: 128px;
  }
}
</style>